// extracted by mini-css-extract-plugin
export var Anchor = "profitTables-module--Anchor--1qTLw";
export var Container = "profitTables-module--Container--1mbYI";
export var ContentTable = "profitTables-module--ContentTable--3E-OR";
export var ActiveRow = "profitTables-module--ActiveRow--1ZiEz";
export var tbody2 = "profitTables-module--tbody2--csz_m";